module.exports = __webpack_public_path__ + "img/document.98c76d0b.png";